import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import gsap from 'gsap'
import './sidebar.css'


const Sidebar = () =>
{
    // Refs for links
    const ref1 = useRef()
    const ref2 = useRef()
    const ref3 = useRef()
    const ref4 = useRef()
    const ref5 = useRef()

    // Animate links on render
    useEffect(()=>{
        gsap.fromTo(ref1.current, {x: window.innerWidth}, {duration: 0.5, x:0, transformOrigin:'right', ease: "expo.out"})
        gsap.fromTo(ref2.current, {x: window.innerWidth}, {delay:0.03, duration: 0.5, x:0, transformOrigin:'right', ease: "expo.out"})
        gsap.fromTo(ref3.current, {x: window.innerWidth}, {delay:0.06, duration: 0.5, x:0, transformOrigin:'right', ease: "expo.out"})
        gsap.fromTo(ref4.current, {x: window.innerWidth}, {delay:0.09, duration: 0.5, x:0, transformOrigin:'right', ease: "expo.out"})
        gsap.fromTo(ref5.current, {x: window.innerWidth}, {delay:0.12, duration: 0.5, x:0, transformOrigin:'right', ease: "expo.out"})
    },[])

    return(
        <div className="sidebar">
            <div className='sidebar-socials' id='link-5' ref={ref5}>
                <a className='footer-links' href='https://www.linkedin.com/in/antinokila/' target="_blank">LINKEDIN</a>
                <Link to="#" className='footer-links' onClick={() => window.location.href = 'mailto:ninokila91@gmail.com'}>GMAIL</Link>
            </div>
            <Link to="/contact" className='sidebar-link' id='link-2' ref={ref2}><p className='sidebar-link-p'>Contact</p></Link>
            <Link to="/about" className='sidebar-link' id='link-3' ref={ref3}><p className='sidebar-link-p'>About</p></Link>
            <Link to="/projects" className='sidebar-link' id='link-4' ref={ref4}><p className='sidebar-link-p'>Work</p></Link>
            <Link to="/" className='sidebar-link' id='link-1' ref={ref1}><p className='sidebar-link-p'>Home</p></Link>
        </div>
    )
}

export default Sidebar